import {User} from "../model/user";

export class UserAccessUtils {

  public static isUserAllowStoreSetting(user: User): boolean {
    try {
      const userAccessExclude = user.userAccessExclude || [];
      return userAccessExclude == null || userAccessExclude.length === 0 || (userAccessExclude.length > 0 && !userAccessExclude.includes('Store Setting'));
    }catch (e) {
      return true;
    }
  }

  public static isUserAllowProduct(user: User): boolean {
    try {
      const userAccessExclude = user.userAccessExclude || [];
      return userAccessExclude == null || userAccessExclude.length === 0 || (userAccessExclude.length > 0 && !userAccessExclude.includes('Product'));
    }catch (e) {
      return true;
    }
  }

  public static isUserAllowStock(user: User): boolean {
    try {
      const userAccessExclude = user.userAccessExclude || [];
      return userAccessExclude == null || userAccessExclude.length === 0 || (userAccessExclude.length > 0 && !userAccessExclude.includes('Stock'));
    }catch (e) {
      return true;
    }
  }

  public static isUserAllowStockViewOnly(user: User): boolean {
    try {
      const userAccessExclude = user.userAccessExclude || [];
      return userAccessExclude == null || userAccessExclude.length == 0 || (userAccessExclude.length > 0 && !userAccessExclude.includes('Stock View Only'));
    }catch (e) {
      return true;
    }
  }

  public static isUserAllowStockWithUnitCost(user: User): boolean {
    try {
      const userAccessExclude = user.userAccessExclude || [];
      return userAccessExclude == null || userAccessExclude.length == 0 || (userAccessExclude.length > 0 && !userAccessExclude.includes('Stock With UnitCost'));
    }catch (e) {
      return true;
    }
  }

  public static isUserAllowStockAll3(user: User): boolean {
    try {
      return this.isUserAllowStock(user) || this.isUserAllowStockViewOnly(user) || this.isUserAllowStockWithUnitCost(user);
    }catch (e) {
      return true;
    }
  }

  public static isUserAllowLowInventory(user: User): boolean {
    try {
      const userAccessExclude = user.userAccessExclude || [];
      return userAccessExclude == null || userAccessExclude.length == 0 || (userAccessExclude.length > 0 && !userAccessExclude.includes('Low Inventory'));
    }catch (e) {
      return true;
    }
  }

  public static isUserAllowOrderTracking(user: User): boolean {
    try {
      const userAccessExclude = user.userAccessExclude || [];
      return userAccessExclude == null || userAccessExclude.length == 0 || (userAccessExclude.length > 0 && userAccessExclude.includes('Order Tracking'));
    }catch (e) {
      return true;
    }
  }



  public static isUserAllowDeleteItem(user: User): boolean {
    try {
      const userAccessExclude = user.userAccessExclude || [];
      return userAccessExclude == null || userAccessExclude.length == 0 || (userAccessExclude.length > 0 && !userAccessExclude.includes('Allow Delete item'));
    }catch (e) {
      return true;
    }
  }

  public static isUserAllowDiscount(user: User): boolean {
    try {
      const userAccessExclude = user.userAccessExclude || [];
      return userAccessExclude == null || userAccessExclude.length == 0 || (userAccessExclude.length > 0 && !userAccessExclude.includes('Discount'));
    }catch (e) {
      return true;
    }
  }

  public static isUserAllowShowProfits(user: User): boolean {
    try {
      const userAccessExclude = user.userAccessExclude || [];
      return userAccessExclude == null || userAccessExclude.length == 0 || (userAccessExclude.length > 0 && !userAccessExclude.includes('Show Profits'));
    }catch (e) {
      return true;
    }
  }

  public static isUserAllowShowAllSalesReport(user: User): boolean {
    try {
      const userAccessExclude = user.userAccessExclude || [];
      return userAccessExclude == null || userAccessExclude.length == 0 || (userAccessExclude.length > 0 && !userAccessExclude.includes('Show All Sales Report'));
    }catch (e) {
      return true;
    }
  }

  public static isUserAllowSalesReport(user: User): boolean {
    try {
      const userAccessExclude = user.userAccessExclude || [];
      return userAccessExclude == null || userAccessExclude.length == 0 || (userAccessExclude.length > 0 && !userAccessExclude.includes('Sales Report'));
    }catch (e) {
      return true;
    }
  }

  public static isUserAllowCancelOrder(user: User): boolean {
    try {
      const userAccessExclude = user.userAccessExclude || [];
      return userAccessExclude == null || userAccessExclude.length == 0 || (userAccessExclude.length > 0 && !userAccessExclude.includes('Cancel Order'));
    }catch (e) {
      return true;
    }
  }
}
